//=====================================================
//　G009：マイページ
//=====================================================

import { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BtnReservationRefirst } from "../../common/BtnReservationReFirst";
import { ReservationCard } from "../../common/ReservationCard";
import { BtnTile } from "../../common/BtnTile";
import { ContentsBox } from "../../common/ContentsBox";
import { ContentsTitle } from "../../common/ContentsTitle";
import { ReservationType } from "../../utils/ConstCommon";
import { CtxNewReservation, CtxClinicInfo, CtxClinicSystemInfo, CtxPatientInfo, CtxPatientDetailInfo, CtxSystemErr } from "../../utils/Contexts";
import { useReservationInfo } from "../../utils/UseReservationInfo";
import { useAuth } from "../../utils/UseAuth";
import { LoadingBox } from "../../common/LoadingBox";

export function G009(){

    const history = useHistory();
    const cserr = useContext(CtxSystemErr);
    const cci = useContext(CtxClinicInfo);
    const ccsi = useContext(CtxClinicSystemInfo);
    const cpi = useContext(CtxPatientInfo);
    const cpdi = useContext(CtxPatientDetailInfo);
    const cnr = useContext(CtxNewReservation);
    const [loadingDone, setLoadingDone] = useState(false);

    const ua = useAuth(); //ログイン情報

    const cri_true = useReservationInfo(ua, cci.data.id,  ua.getPatientNo() , true, cserr);
    const cri_false = useReservationInfo(ua, cci.data.id, ua.getPatientNo() , false, cserr);

    const noReservation = 
            ( cri_false.loaded && cri_true.loaded && 
                (
                    ( cpi.data.reFirstVisitEnable ) || 
                    ( cri_true.data.length + cri_false.data.length <= 0 ) 
                ) 
            ); 
    const minHeight = noReservation ? 0:300; 

    // タイトル追加処理
    useEffect(function(){
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - マイページ";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - マイページ";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(
        function(){
            if ( cri_true.loaded && cri_false.loaded ) {
                if(!ua.isLoggedIn()) {
                    history.push("/");
                }
                if (cnr.type !== ReservationType.None){
                    // 予約フローから戻ったとき
                    if(cnr.type === ReservationType.Return    // 再診
                    || cnr.type === ReservationType.Change    // 変更
                    || cnr.type === ReservationType.Cancel    // キャンセル
                    || cnr.type === ReservationType.ReFirst   // 再初診
                    ){
                        // 患者情報を再度取得
                        let errMess = cpi.getData(cci.data.id, ua.getPatientNo());
                        if(errMess) {
                            cserr.setErrmess(errMess);
                        }
                    }
                }
                // 予約情報を初期化
                cnr.create(ReservationType.None, {});
                setLoadingDone(true);
            }
        },
        // history、uaを更新するため第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ cri_true.loaded, cri_false.loaded ]
    );

    //再初診ボタンクリック処理
    function clickReFirst(){
        cnr.create(ReservationType.ReFirst, {});
        history.push("/reservation/menu");
    }

    //患者情報変更ボタンクリック処理
    function clickChangePatientInfo(){
        cpdi.update({done: false});
        history.push("/mypage/user");
    }

    return (
        <>
            {cci.data.comment.clinicComment2 !== "" &&
                <ContentsBox>
                    <h2 className="contents-title hospital-info">医院からのお知らせ</h2>
                    <div className="text-multiline">
                        {cci.data.comment.clinicComment2}
                    </div>
                </ContentsBox>
            }        
            <ContentsBox>
                <ContentsTitle title="マイページ" />
                <h2 className="contents-title next-reservation">次回のご予約</h2>
                <LoadingBox overlay={true} loadingDone={loadingDone} minHeight={minHeight}>
                    { noReservation && 
                        <>
                            <div className="messagebox-info">
                                現在、次回のご予約はありません。
                            </div>
                            { ( ccsi.data.usability.reFirst ) &&
                                <ul className="next-reservation-list">
                                    <li>
                                        <BtnReservationRefirst enable={cpi.data.reFirstVisitEnable} onClick={function(){clickReFirst()}} />
                                    </li>   
                                </ul>
                            }
                        </>
                    }
                    { !noReservation &&
                        <ul className="next-reservation-list">
                        { ( cri_false.data.length > 0 && !cpi.data.reFirstVisitEnable ) && 
                            <>
                            {ccsi.data.usability.appointment.add && 
                                <div className="messagebox-error">
                                日時未決定の予約が存在します。予約日時を登録してください。
                                </div>
                            }
                            {
                                cri_false.data.map( 
                                    function( val, idx ){
                                        return (
                                            <li key={idx}>                    
                                            <ReservationCard idx={idx+1} card={val} key={idx} /> 
                                            </li>
                                        )
                                    }
                                )
                            }
                            </>
                        }
                        {cri_true.data.length > 0 &&
                            <>
                            {
                                cri_true.data.map( 
                                    function( val, idx ){
                                        return (
                                            <li key={cri_false.data.length + idx }>                    
                                            <ReservationCard idx={cri_false.data.length + idx + 1} card={val}  key={idx} /> 
                                            </li>
                                        )
                                    }
                                )
                            }
                            </>
                        }
                        </ul>
                    }
                </LoadingBox>
            </ContentsBox>
            <ContentsBox>
                <div className="btn-tile-wrapper patient-menu">
                    <BtnTile iconfont="icon-hospital" title="受診履歴確認" onClick={function(){history.push("/mypage/history")}} />
                    <BtnTile iconfont="icon-tooth-white" title="患者情報変更" onClick={function(){clickChangePatientInfo()}} />
                </div>
            </ContentsBox>
        </>
    );

}